import { Injectable, Output, EventEmitter } from '@angular/core';
import { VERIFICATION_METHODS } from '@shared/constants/verification-methods';

@Injectable({
  providedIn: 'root'
})
export class DragAndDropService {
  currentCount;
  totalFilesCount;
  totalExpectedBytes;
  netWorthIBytes;
  netWorthIIBytes;
  currentTotalBytes;
  currentBytesHolder;
  expectedFileIds;
  expectedFileIdsForNetWorthI;
  expectedFileIdsForNetWorthII;
  successfulFileIds;
  resubmitted;
  interruptedVerificationUpload;
  submitEnabled;
  uploadingStatuses;
  uploadingStatusesForNetWorthI;
  uploadingStatusesForNetWorthII;
  numFailedFiles;
  submitText;

  constructor() {
    this.resetDefault();
  }

  @Output()
  uploadingFiles: EventEmitter<any> = new EventEmitter();

  @Output()
  enablingFlagForVerificationFiles: EventEmitter<any> = new EventEmitter();

  @Output()
  enablingFlagNetWorthFilesI: EventEmitter<any> = new EventEmitter();

  @Output()
  enablingFlagNetWorthFilesII: EventEmitter<any> = new EventEmitter();

  @Output()
  updatingVerificationStatus: EventEmitter<any> = new EventEmitter();

  @Output()
  updatingUploadPercentage: EventEmitter<any> = new EventEmitter();

  @Output()
  updatingFileIds: EventEmitter<any> = new EventEmitter();

  @Output()
  updatingInterruptedVerificationFlag: EventEmitter<any> = new EventEmitter();

  @Output()
  updatingNumFailedFilesFlag: EventEmitter<any> = new EventEmitter();

  @Output()
  updatingSubmitButtonFlag: EventEmitter<any> = new EventEmitter();

  @Output()
  showingAddFundsBanner: EventEmitter<any> = new EventEmitter();

  @Output()
  abortingAllUploads: EventEmitter<any> = new EventEmitter();

  @Output()
  resettingDragAndDrop: EventEmitter<any> = new EventEmitter();

  @Output()
  updatingUploadingStatus: EventEmitter<any> = new EventEmitter();

  resetDefault() {
    this.currentCount = 0;
    this.totalFilesCount = 0;
    this.totalExpectedBytes = 0;
    this.netWorthIBytes = 0;
    this.netWorthIIBytes = 0;
    this.currentTotalBytes = 0;
    this.interruptedVerificationUpload = false;

    this.resubmitted = false;
    this.currentBytesHolder = [];
    this.expectedFileIds = [];
    this.successfulFileIds = [];
    this.expectedFileIdsForNetWorthI = [];
    this.expectedFileIdsForNetWorthII = [];
    this.submitEnabled = true;

    this.uploadingStatuses = [];
    this.uploadingStatusesForNetWorthI = [];
    this.uploadingStatusesForNetWorthII = [];
    this.numFailedFiles = 0;
    this.submitText = 'Submit';
  }

  triggerUploadFiles() {
    this.uploadingFiles.emit();
  }

  setFlagForVerificationFiles(flag) {
    this.enablingFlagForVerificationFiles.emit(flag);
  }

  setFlagNetWorthFilesI(flag) {
    this.enablingFlagNetWorthFilesI.emit(flag);
  }

  setFlagNetWorthFilesII(flag) {
    this.enablingFlagNetWorthFilesII.emit(flag);
  }

  updateVerificationStatus(status) {
    this.updatingVerificationStatus.emit(status);
  }

  abortAllUploads() {
    this.abortingAllUploads.emit();
  }

  updateNetWorthTotalBytes() {
    this.totalExpectedBytes = this.netWorthIBytes + this.netWorthIIBytes;
  }

  setTotalBytes(indentityId, totalBytes) {
    if (indentityId === 2) {
      this.netWorthIBytes = 0;
      this.netWorthIBytes = totalBytes;
    } else if (indentityId === 3) {
      this.netWorthIIBytes = 0;
      this.netWorthIIBytes = totalBytes;
    } else {
      this.totalExpectedBytes = 0;
      this.totalExpectedBytes = totalBytes;
    }
  }

  setExpectedFileIds(indentityId, ids) {
    if (indentityId === 2) {
      this.expectedFileIdsForNetWorthI = [];
      this.expectedFileIdsForNetWorthI = ids;
    } else if (indentityId === 3) {
      this.expectedFileIdsForNetWorthII = [];
      this.expectedFileIdsForNetWorthII = ids;
    } else {
      this.expectedFileIds = [];
      this.expectedFileIds = ids;
    }
  }

  updateNetWorthExpectedFileIds() {
    this.expectedFileIds = this.expectedFileIdsForNetWorthI.concat(
      this.expectedFileIdsForNetWorthII
    );
  }

  updateSuccessfulFileIds(id, action) {
    if (action === 'ADD') {
      if (!this.isFileAlreadyUploaded(id)) {
        this.successfulFileIds.push(id);
      }
    } else {
      this.successfulFileIds = this.successfulFileIds.filter(sId => sId !== id);
    }
    this.updatingFileIds.emit(this.isAllFilesSuccessful());
  }

  getSuccessfulFileIdsCount() {
    return this.successfulFileIds.length;
  }

  updateExpectedFileIds(id, action) {
    if (action === 'ADD') {
      if (!this.isFileExistInExpected(id)) {
        this.expectedFileIds.push(id);
      }
    } else {
      this.expectedFileIds = this.expectedFileIds.filter(eId => eId !== id);
    }
    this.updatingFileIds.emit(this.isAllFilesSuccessful());
  }

  getExpectedFileIdsCount() {
    return this.expectedFileIds.length;
  }
  isAllFilesSuccessful() {
    let ret = true;
    if (
      this.successfulFileIds.length === this.expectedFileIds.length &&
      this.successfulFileIds.length > 0 &&
      this.expectedFileIds.length > 0
    ) {
      this.successfulFileIds.map(id => {
        if (this.expectedFileIds.indexOf(id) === -1) {
          ret = false;
        }
      });
    } else {
      ret = !ret;
    }
    return ret;
  }

  updateNumberOfFailedFiles(count) {
    this.numFailedFiles += count;
    this.updatingNumFailedFilesFlag.emit(this.numFailedFiles);
  }

  resetNumberOfFailedFiles() {
    this.numFailedFiles = 0;
    this.updatingNumFailedFilesFlag.emit(this.numFailedFiles);
  }

  isFileAlreadyUploaded(id) {
    return this.successfulFileIds.indexOf(id) > -1;
  }

  isFileExistInExpected(id) {
    return this.expectedFileIds.indexOf(id) > -1;
  }

  resetCurrentBytesHolder() {
    this.currentTotalBytes = [];
  }

  updateUploadPercentage(bytes, id) {
    this.setSubmitButtonStatus(false);
    const currentIds = this.currentBytesHolder.map(currentBytes => {
      return currentBytes.id;
    });

    const ind = currentIds.indexOf(id);
    if (ind < 0) {
      this.currentBytesHolder.push({ id: id, bytes: bytes });
    } else {
      this.currentBytesHolder[ind].bytes = bytes;
    }
    this.currentTotalBytes = 0;
    this.currentTotalBytes = this.currentBytesHolder.reduce(
      (acc, cur) => acc + parseInt(cur.bytes, 10),
      0
    );
    const percentage = Math.round(
      (this.currentTotalBytes / this.totalExpectedBytes) * 100
    );

    if (percentage < 100) {
      this.submitText = `${percentage}% uploaded`;
    } else {
      this.submitText = `Sending`;
    }
    this.updatingUploadPercentage.emit(this.submitText);
  }

  setAlreadySubmitted(status) {
    this.resubmitted = status;
  }

  isReSubmitted() {
    return this.resubmitted;
  }

  setSubmitButtonStatus(status) {
    this.submitEnabled = status;
    this.updatingSubmitButtonFlag.emit(status);
  }

  isSubmitEnabled() {
    return this.submitEnabled;
  }

  resetDragAndDrop() {
    this.resettingDragAndDrop.emit();
  }

  setInterruptedVerificationStatus(status) {
    this.interruptedVerificationUpload = status;
    this.updatingInterruptedVerificationFlag.emit(
      this.interruptedVerificationUpload
    );
  }

  setAddFundsBannerStatus(status) {
    this.showingAddFundsBanner.emit(status);
  }

  updateNetWorthUploadingStatus() {
    this.uploadingStatuses = this.uploadingStatusesForNetWorthI.concat(
      this.uploadingStatusesForNetWorthII
    );
  }

  setUploadingStatus(indentityId, statuses) {
    if (indentityId === 2) {
      this.uploadingStatusesForNetWorthI = [];
      this.uploadingStatusesForNetWorthI = statuses;
    } else if (indentityId === 3) {
      this.uploadingStatusesForNetWorthII = [];
      this.uploadingStatusesForNetWorthII = statuses;
    } else {
      this.uploadingStatuses = [];
      this.uploadingStatuses = statuses;
    }
  }
  updateUploadStatus(id, status) {
    this.uploadingStatuses = this.uploadingStatuses.map(stat => {
      if (stat.id === id) {
        stat.uploading = status;
      }
      return stat;
    });
  }

  isStillUploadingStatus() {
    return this.uploadingStatuses.filter(status => status.uploading).length > 0;
  }

  resetUploadingStatus() {
    this.uploadingStatuses = this.uploadingStatuses.map(stat => {
      stat.uploading = false;
      return stat;
    });
  }

  updateSubmitText() {
    if (!this.isStillUploadingStatus() && this.numFailedFiles > 0) {
      this.submitText = 'Re-submit';
      this.setSubmitButtonStatus(true);
    }

    this.updatingUploadPercentage.emit(this.submitText);
  }
}
